var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 10a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 8 10ZM8 10v1.5","stroke":"currentColor","strokeWidth":"1.333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13 5.5H3a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5ZM5.75 5.5V3.25a2.25 2.25 0 1 1 4.5 0V5.5","stroke":"currentColor","strokeWidth":"1.333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Lock.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none"};

module.exports = Lock;

Lock.default = Lock;
